export function SidebarDivider() {

  return (
    <hr />
  )
}
